/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import AlertTypeSummary from './alertTypeSummary';
import AlertSubscriptionForm from './alertSubscriptionForm';

var AlertTypeDetails = function AlertTypeDetails(props) {
  var alertType = props.alertType;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AlertTypeSummary, {
    alertType: alertType
  }), /*#__PURE__*/React.createElement(AlertSubscriptionForm, props));
};

AlertTypeDetails.propTypes = {
  alertType: PropTypes.object
};
export default AlertTypeDetails;